import { GET_PAYMENTS_REQUEST, GET_PAYMENTS_SUCCESS, GET_PAYMENTS_FAIL, 
    CREATE_PAYMENT_REQUEST, CREATE_PAYMENT_SUCCESS, CREATE_PAYMENT_FAIL,
    UPDATE_PAYMENT_REQUEST, UPDATE_PAYMENT_SUCCESS, UPDATE_PAYMENT_FAIL,
    DELETE_PAYMENT_REQUEST, DELETE_PAYMENT_SUCCESS, DELETE_PAYMENT_FAIL } from "../types/paymentTypes";
import Axios from 'axios';
import cogoToast from 'cogo-toast';
import APP_CONSTANT from '../../config/constants';


export const deletePayment = (id) => async (dispatch) => {

    dispatch({ type: DELETE_PAYMENT_REQUEST });

    try {
        
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "paymentReferenceNo": id
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/payment/delete`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: DELETE_PAYMENT_SUCCESS, payload: data });
        window.location.reload()
            
    } catch (error) {  
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: DELETE_PAYMENT_FAIL, payload: error.message })
    }
}

export const updatePayment = (updatePaymentData) => async (dispatch) => {

    dispatch({ type: UPDATE_PAYMENT_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/payment/update`, updatePaymentData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: UPDATE_PAYMENT_SUCCESS, payload: data });

        if(data.status === 0){
            cogoToast.error(data.message, { position: 'top-right' })
        } else {
            cogoToast.success(data.message, { position: 'top-right' }).then(()=> {
                window.location.href = '/payment';
            })
        }     
            
    } catch (error) {   
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: UPDATE_PAYMENT_FAIL, payload: error.message })
    }
}

export const createPayment = (createPaymentData) => async (dispatch) => {

    dispatch({ type: CREATE_PAYMENT_REQUEST });

    try {

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/payment/create`, createPaymentData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: CREATE_PAYMENT_SUCCESS, payload: data });

        if(data.status === 0){
            cogoToast.error(data.message, { position: 'top-right' })
        } else {
            cogoToast.success(data.message, { position: 'top-right' }).then(()=> {
                window.location.href = '/payment';
            })
        } 
                
    } catch (error) {   
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: CREATE_PAYMENT_FAIL, payload: error.message })
    }
}

export const getPayments = (id) => async (dispatch) => {

    dispatch({ type: GET_PAYMENTS_REQUEST });

    try {
        
        const headerData = (id) => {
            if(id){
                return {
                    "api_token": localStorage.getItem('apiToken'),
                    "customerNo": localStorage.getItem('customerNo'),
                    "userId": localStorage.getItem('userId'),
                    "paymentId": id 
                }
            }else{
                return {
                    "api_token": localStorage.getItem('apiToken'),
                    "customerNo": localStorage.getItem('customerNo'),
                    "userId": localStorage.getItem('userId'),
                }
            }
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/payment/getPayments`, headerData(id), {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });

        dispatch({ type: GET_PAYMENTS_SUCCESS, payload: data });


            
    } catch (error) {
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_PAYMENTS_FAIL, payload: error.message })
    }
}

export const getFilteredPayments = (filteredData) => async (dispatch) => {

    dispatch({ type: GET_PAYMENTS_REQUEST });

    try {
        
       
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}purchase/payment/getPayments`, filteredData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_PAYMENTS_SUCCESS, payload: data });


            
    } catch (error) {
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_PAYMENTS_FAIL, payload: error.message })
    }
}
